<pinch-zoom
  #zoom
  (events)="events($event)"
  [auto-zoom-out]="true"
  [autoHeight]="true"
  [disableZoomControl]="'never'"
  [double-tap-scale]="4.5"
  [limit-zoom]="4.5"
  [limitPan]="true"
  [ngStyle]="{
    'height.px': 300,
    'border-radius.%': 0
  }"
  [properties]="pinchProps"
  [zoomControlPosition]="'right'"
  [zoomControl]="'two-buttons'"
  backgroundColor="transparent"
  overflow="hidden"
>
  <img
    #img
    [src]="
      {
        photoId: pickedPhoto.photo.photoId
      }
        | getImageUrl
          : pickedPhoto.groupId
          : 'photographer'
          : imagesContext
          : contextId
          : 600
        | async
    "
    draggable="false"
    (load)="imageLoaded$.next(undefined)"
  />
</pinch-zoom>
